import {apiCall} from "../../functions/utils"

export const onChangeNotes = (e, item, model) => {
    return async (dispatch) => {
        let data = {
            text: e.value,
            model,
            phone: item.sender_phone,
        }
        const res = await apiCall(true, "POST", `/api/notes/store`, data)
    }
}

export const saveFcmToken = (token) => {
    return async (dispatch) => {
        try {
            let form = new FormData()
            form.append('fcm_token', token)
            return await apiCall(true, "POST", `/api/users/update-fcm-token`, form, false, true, true);
        } catch (e) {
            console.error("Error saving FCM token:", e);
        }
    };
};